import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import ContactListItem from 'components/Contacts/ContactListItem';
import dropdownNavigation from 'components/Dropdown/DropdownNavigation';
import OneTimeMeeting, { ONE_TIME_LIST_ITEM } from 'models/OneTimeMeeting';
import ReactInfinite from 'react-infinite';
import ReactDOM from 'react-dom';
import classes from './StartCallModal.module.scss';

const ELEMENT_HEIGHT = 42;
const messages = defineMessages({
  oneTimeResult: { id: 'search.call.oneTime', defaultMessage: 'New one-time meeting' },
  emptyMessage: { id: 'components.globalSearch.emptyMessage', defaultMessage: 'There are no matches for your search.' }
});

class StartCallSearch extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.selectionIndex > this.props.selectionIndex) {
      this.scrollToNextResult();
    }

    if (nextProps.selectionIndex < this.props.selectionIndex) {
      this.scrollToPreviousResult();
    }
  }

  /* eslint-disable react/no-find-dom-node */
  getScrollTop = () => ReactDOM.findDOMNode(this).scrollTop;

  setScrollTop = (scrollTop) => {
    ReactDOM.findDOMNode(this).scrollTop = scrollTop;
  };
  /* eslint-enable react/no-find-dom-node */

  scrollToNextResult = () => {
    const highlightedIndex = this.props.selectionIndex + 2;
    if (highlightedIndex * ELEMENT_HEIGHT > this.getScrollTop() + this.props.maxItems * ELEMENT_HEIGHT) {
      this.setScrollTop((highlightedIndex - this.props.maxItems) * ELEMENT_HEIGHT);
    }
  };

  scrollToPreviousResult = () => {
    const highlightedIndex = this.props.selectionIndex - 1;
    if (highlightedIndex * ELEMENT_HEIGHT < this.getScrollTop()) {
      this.setScrollTop(highlightedIndex * ELEMENT_HEIGHT);
    }
  };

  render() {
    const {
      searchContacts,
      allContacts,
      handleSelectContact,
      maxItems,
      searchString,
      selectionIndex,
      showCustomDial,
      showOneTimeMeetings,
      isSearching,
      intl
    } = this.props;
    let returnArray = [];

    let arrayShift = 0;

    const prependOneTimeMeetingItem = () => {
      if (showOneTimeMeetings) {
        returnArray.unshift(
          <ContactListItem
            className={classes.listItem}
            contact={
              new OneTimeMeeting({
                name: intl.formatMessage(messages.oneTimeResult)
              })
            }
            dataTestTag="startCall-newOneTime"
            fontSize="1.1em"
            handleSelectContact={handleSelectContact}
            isBold
            isFirstContact
            isHighlighted={selectionIndex === 0}
            isSelf
            key={ONE_TIME_LIST_ITEM}
            matches={[]}
            noButtons
            noContactMeDirectlyOption
          />
        );
      }
    };

    if (showOneTimeMeetings) {
      arrayShift = 1;
    }

    if (searchContacts.length && searchString) {
      returnArray = searchContacts.map((result, index) => (
        <ContactListItem
          key={result.contact.id}
          className={classes.listItem}
          contact={result.contact}
          matches={result.matches ? result.matches.name : []}
          handleSelectContact={handleSelectContact}
          isHighlighted={index === selectionIndex}
          fontSize="1.1em"
          noButtons
          greyOutUnCallable
          dataTestTag="startCall-contact"
        />
      ));
      if (showOneTimeMeetings) {
        prependOneTimeMeetingItem();
      }
    } else if (!searchString || !searchString.length) {
      returnArray = allContacts.map((result, index) => (
        <ContactListItem
          key={result.id}
          className={classes.listItem}
          contact={result}
          matches={[]}
          handleSelectContact={handleSelectContact}
          isHighlighted={index === selectionIndex - arrayShift}
          fontSize="1.1em"
          noButtons
          greyOutUnCallable
          dataTestTag="startCall-contact"
        />
      ));

      if (showOneTimeMeetings) {
        prependOneTimeMeetingItem();
      }
    }

    if (showCustomDial) {
      returnArray.unshift(
        <ContactListItem
          key={searchString}
          className={classes.listItem}
          contact={{
            name: searchString,
            id: searchString,
            dialString: searchString,
            isManual: true
          }}
          matches={[]}
          handleSelectContact={handleSelectContact}
          isHighlighted={selectionIndex === 0}
          fontSize="1.1em"
          noButtons
          dataTestTag="startCall-custom"
        />
      );
    } else if (searchString && searchString.length && !searchContacts.length && !isSearching) {
      returnArray = (
        <ContactListItem
          key={searchString}
          className={`${classes.listItem} ${classes.noResults}`}
          contact={{
            name: intl.formatMessage(messages.emptyMessage),
            id: 'noResults',
            dialString: ''
          }}
          matches={[]}
          handleSelectContact={handleSelectContact}
          isHighlighted={selectionIndex === 0}
          fontSize="1.1em"
          noButtons
          greyOutUnCallable
          hideIcon
          dataTestTag="startCall-noResults"
        />
      );
    }

    if (isSearching && !returnArray.length) {
      returnArray = (
        <div key="searchSpinner" className={classes.loadingContainer}>
          <div className={classes.loadingSpinner} />
        </div>
      );
    }

    return (
      <ReactInfinite
        className={classes.infiniteScroll}
        containerHeight={maxItems * ELEMENT_HEIGHT}
        elementHeight={ELEMENT_HEIGHT}
        styles={{ scrollableStyle: { overflowY: 'auto' } }}
      >
        {returnArray}
      </ReactInfinite>
    );
  }
}

StartCallSearch.propTypes = {
  handleSelectContact: PT.func.isRequired,
  searchContacts: PT.array.isRequired,
  allContacts: PT.array.isRequired,
  searchString: PT.string,
  maxItems: PT.number,
  selectionIndex: PT.number,
  showOneTimeMeetings: PT.bool,
  showCustomDial: PT.bool,
  isSearching: PT.bool,
  intl: PT.object
};

export default dropdownNavigation(injectIntl(StartCallSearch));
